import { PATH_HOME } from "@configs";
import MerchantStore from "@Rocket-Innovation/components/store/useMerchantStore";
import { useHistory } from "react-router";
import styled from "styled-components";

export const PageError404 = () => {
    const history = useHistory();
    const themeColor = (MerchantStore.getState().merchant as any)?.themes.themeColor || "#ffffff";

    const handleGoHome = () => {
        history.push(PATH_HOME);
    };

    return (
        <Container>
            <Content>
                <ErrorCode themeColor={themeColor}>404</ErrorCode>
                <Title themeColor={themeColor}>Page Not Found</Title>
                <Description>
                    The page you are looking for might have been removed, had its name changed, or
                    is temporarily unavailable.
                </Description>
                <HomeButton themeColor={themeColor} onClick={handleGoHome}>
                    Go to Homepage
                </HomeButton>
            </Content>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    width: 100%;
    height: 100vh;
    justify-content: center;
    align-items: center;
    background: whitesmoke;
    padding: 20px;
`;

const Content = styled.div`
    text-align: center;
    background: white;
    padding: 60px 40px;
    border-radius: 20px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    max-width: 500px;
    width: 100%;
    animation: fadeIn 0.6s ease-in-out;

    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(-20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`;

const ErrorCode = styled.h1<{ themeColor: string }>`
    font-size: 120px;
    font-weight: 800;
    margin: 0;
    background: ${(p) => p.themeColor};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    line-height: 1;
    margin-bottom: 20px;

    @media (max-width: 480px) {
        font-size: 80px;
    }
`;

const Title = styled.h2<{ themeColor: string }>`
    font-size: 28px;
    font-weight: 600;
    color: ${(p) => p.themeColor};
    margin: 0 0 16px 0;

    @media (max-width: 480px) {
        font-size: 24px;
    }
`;

const Description = styled.p`
    font-size: 16px;
    color: #718096;
    line-height: 1.6;
    margin: 0 0 32px 0;

    @media (max-width: 480px) {
        font-size: 14px;
    }
`;

const HomeButton = styled.button<{ themeColor: string }>`
    background: ${(p) => p.themeColor};
    color: white;
    border: none;
    padding: 14px 32px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 50px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(102, 126, 234, 0.6);
    }

    &:active {
        transform: translateY(0);
    }

    @media (max-width: 480px) {
        padding: 12px 28px;
        font-size: 14px;
    }
`;
